import { createRouter } from "@tanstack/react-router";
import { queryClient } from "./lib/queryClient";
import { routeTree } from "./routeTree.gen";

declare module "@tanstack/react-router" {
    interface Register {
      router: typeof router;
    }
  }

export const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    basepath: "/shop",
    context: {
      queryClient,
    },
  });
